<template>
  <slot v-if="!hasError" />
</template>

<script setup lang="ts">
import { onErrorCaptured, ref } from 'vue'

import { useLogger } from '@backmarket/nuxt-module-logger/useLogger'

const logger = useLogger()
const hasError = ref(false)

onErrorCaptured((error) => {
  logger.error('[SHOPPING_ASSISTANT] Error boundary caught', {
    cause: error.cause,
    message: error.message,
    owners: ['bot-group-ai-shopping-assistant-front'],
  })

  hasError.value = true

  // Return "false" to prevent the error to bubble up
  return false
})
</script>
